import { To } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Card } from '@factorialco/f0-react'
import { Target } from '@factorialco/f0-react/icons/app'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import {
  PerformanceGoalsEmployeeProgressFragment,
  PerformanceGoalsKeyResultsCardFragment,
} from 'generated/resources/graphql'

export type GoalsEmployee = PerformanceGoalsKeyResultsCardFragment & {
  progresses?: PerformanceGoalsEmployeeProgressFragment[]
}

export function buildAvatarFromEmployee(employee: {
  fullName?: string | null
  access?: { avatar?: string | null } | null
}) {
  const [firstName, ...lastNameParts] = employee.fullName?.split(' ') ?? []
  return {
    type: 'person' as const,
    firstName: firstName ?? '',
    lastName: lastNameParts.join(' ') ?? '',
    ...(employee.access?.avatar && { src: buildUrl(employee.access.avatar) }),
  }
}

interface YourProgressCardProps {
  goalsEmployee: GoalsEmployee
  to: To
}

export const YourProgressCard: React.FC<YourProgressCardProps> = ({ goalsEmployee, to }) => {
  const { employee } = goalsEmployee
  if (!employee) return null

  const cycleProgress = goalsEmployee.progresses?.[0]
  const metricSummary = goalsEmployee.metricSummary
  const progress = cycleProgress?.progress ?? metricSummary?.averageProgress ?? 0
  const needsAttention = cycleProgress?.needsAttention ?? metricSummary?.needsAttention ?? false

  const avatar = buildAvatarFromEmployee(employee)
  const linkUrl = typeof to === 'string' ? to : (to.pathname ?? '')

  const metadataItem = {
    icon: Target,
    ...(needsAttention && {
      tooltip: i18n.t('performance_goals.progress_summary.needs_attention_tooltip'),
    }),
    property: {
      type: 'progressBar' as const,
      value: {
        value: progress,
        max: 100,
        label: `${i18n.formatNumber(progress)}%`,
      },
    },
  }

  return (
    <Box minWidth="s300">
      <F0Card
        compact
        avatar={avatar}
        title={i18n.t('performance_goals.key_results_card.title_you')}
        description={i18n.t('performance_goals.key_results_card.description')}
        link={linkUrl || undefined}
        metadata={[metadataItem]}
      />
    </Box>
  )
}
